__turbopack_context__.v({
  "dropdown": "dropdownMenu-module-scss-module__kYORiq__dropdown",
  "dropdown-menu": "dropdownMenu-module-scss-module__kYORiq__dropdown-menu",
  "dropdown-menu-hidden": "dropdownMenu-module-scss-module__kYORiq__dropdown-menu-hidden",
  "dropdown-menu-user-types": "dropdownMenu-module-scss-module__kYORiq__dropdown-menu-user-types",
  "selected": "dropdownMenu-module-scss-module__kYORiq__selected",
});
